import React from "react";
import flowImage from "../../assets/images/flowImage.png";
import roomIcon from "../../assets/icons/roomIcon.png";
import customerRooms from "../../data/dummyData/customerRooms";



const CustomerRooms = () => {
  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Customer Rooms</h1>
        <button className="bg-primary text-white px-4 py-2 rounded-lg hover:bg-primary-dark transition">
          New Room +
        </button>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {customerRooms.map((room) => (
          <div
            key={room.id}
            className="w-full max-w-[250px] mx-auto border border-gray-300 rounded-lg overflow-hidden bg-white shadow-sm hover:shadow-md transition"
          >
            {/* Top Image */}
            <img
              src={flowImage}
              alt={`${room.name} Preview`}
              className="w-full h-28 object-cover rounded-t-lg"
            />

            {/* Content */}
            <div className="p-3">
              {/* Icon and Title */}
              <div className="flex items-center mb-1">
                <img
                  src={roomIcon}
                  alt="Room Icon"
                  className="w-8 h-8 mr-2"
                />
                <div>
                  <h2 className="text-sm font-medium text-gray-800">
                    {room.name}
                  </h2>
                  <p className="text-xs text-gray-500">{room.description}</p>
                </div>
              </div>

              {/* Details */}
              <p className="text-xs text-gray-600 mt-2">
                <strong className="text-purple-500 font-medium">
                  Attended To:
                </strong>{" "}
                {room.attendedTo}
              </p>
              <p className="text-xs text-gray-600">
                <strong className="text-purple-500 font-medium">
                  Remaining Time:
                </strong>{" "}
                {room.remainingTime}
              </p>
              <p className="text-xs text-gray-600">
                <strong className="text-purple-500 font-medium">Status:</strong>{" "}
                {room.status}
              </p>
            </div>

            {/* Footer */}
            <div className="px-3 py-1 text-xs text-gray-500 text-right rounded-b-lg">
              <span>{room.date}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomerRooms;
